export default "__VITE_ASSET__BrBxn4DR__"